export default __webpack_public_path__ + "static/media/white02.0c453cef.jpg";